(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-slide"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    const track = root.querySelector('.slideshow__track');
    const slides = Array.from(root.querySelectorAll('.slideshow__slide'));
    const dots = Array.from(root.querySelectorAll('.slideshow__dot'));
    const prev = root.querySelector('.slideshow__arrow--prev');
    const next = root.querySelector('.slideshow__arrow--next');
    if (slides.length < 2) return;

    const autoplay = root.dataset.autoplay === 'true';
    const speed = (parseInt(root.dataset.speed, 10) || 6) * 1000;
    const loop = root.dataset.loop === 'true';
    let current = 0, timer = null;

    function goTo(i) {
      if (i < 0) i = loop ? slides.length - 1 : 0;
      if (i >= slides.length) i = loop ? 0 : slides.length - 1;
      current = i;
      track.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' });
      update();
    }
    function update() {
      dots.forEach((d, x) => d.classList.toggle('is-active', x === current));
      slides.forEach((s, x) => s.setAttribute('aria-hidden', x === current ? 'false' : 'true'));
    }
    function start() { if (autoplay) { stop(); timer = setInterval(() => goTo(current + 1), speed); } }
    function stop() { if (timer) clearInterval(timer); }

    let raf;
    track.addEventListener('scroll', () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        const idx = Math.round(track.scrollLeft / track.clientWidth);
        if (idx !== current) { current = idx; update(); }
      });
    }, { passive: true });

    dots.forEach(d => d.addEventListener('click', () => { goTo(+d.dataset.goto); start(); }));
    if (next) next.addEventListener('click', () => { goTo(current + 1); start(); });
    if (prev) prev.addEventListener('click', () => { goTo(current - 1); start(); });

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    track.addEventListener('touchstart', stop, { passive: true });
    track.addEventListener('touchend', () => setTimeout(start, 4000), { passive: true });

    root.addEventListener('keydown', e => {
      if (e.key === 'ArrowLeft') { goTo(current - 1); start(); }
      if (e.key === 'ArrowRight') { goTo(current + 1); start(); }
    });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(es => es.forEach(en => en.isIntersecting ? start() : stop()), { threshold: 0.2 }).observe(root);
    } else start();
  }
  document.querySelectorAll('.slideshow').forEach(init);
  document.addEventListener('shopify:section:load', e => {
    const el = e.target.querySelector('.slideshow'); if (el) init(el);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
